<template>
  <div>
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{ registration.createdAt | formatDate }}</v-list-item-title>
          <v-list-item-subtitle>Registration date</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{ registration.updatedAt | formatDate }}</v-list-item-title>
          <v-list-item-subtitle>Date updated</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'RegistrationApplicationDetails',

  props: {
    registrationId: {
      type: String,
      required: true
    }
  },

  data: () => ({
    registration: {}
  }),

  apollo: {
    registration: {
      query: gql`query GetRegistration($id: MongoID!) {
        registration: registrationById(_id: $id) {
          _id
          createdAt
          updatedAt
          status
        }
      }`,
      variables () {
        return {
          id: this.registrationId
        }
      },
      error (e) { this.$emit('error', e) }
    }
  }
}
</script>
